require('../../coverage/events/eventsService');
require('./manageReminderService');
require('./reminderFrequencyListService');
require('../../fhApp/mainErrorService');
require('./remindersListService');

"use strict";

angular.module('app.myHockeyTv.manageReminders.manageRemindersController', [
  'app.coverage.events.eventsService',
  'app.myHockeyTv.manageReminders.manageRemindersService',
  'app.myHockeyTv.manageReminders.reminderFrequencyListService',
  'app.mainErrorService',
  'app.myHockeyTv.manageReminders.remindersListService'
])
  .controller('app.myHockeyTv.manageReminders.manageRemindersController', [
    '$scope',
    'app.coverage.events.eventsService',
    'app.myHockeyTv.manageReminders.manageRemindersService',
    'app.myHockeyTv.manageReminders.reminderFrequencyListService',
    'mainError',
    'app.myHockeyTv.manageReminders.remindersListService',
    'defaultOptions',
    function ($scope, events, manageReminder, reminderFrequencyList, mainError, remindersList, defaultOptions) {
      let init, retrieveEvents;

      $scope.reminder = null;
      $scope.events = events;
      $scope.remindersList = remindersList;
      $scope.reminderFrequencyList = reminderFrequencyList;
      $scope.manageReminder = manageReminder;
      $scope.event_teams = null;
      $scope.hours_before = [
        {value: 1, description: '1 hour before'},
        {value: 6, description: '6 hours before'},
        {value: 12, description: '12 hours before'},
        {value: 24, description: '24 hours before'}
      ];

      init = function () {
        $scope.clear();
        retrieveEvents(defaultOptions.icalid_fk);
        reminderFrequencyList.retrieve();
        return remindersList.retrieve();
      };
      retrieveEvents = function (icalid) {
        let event_list_params;
        if (icalid) {
          event_list_params = {
            include: icalid
          };
        } else {
          event_list_params = null;
        }
        return events.retrieve(event_list_params);
      };
      $scope.save = function () {
        return manageReminder.save($scope.reminder)
          .then(
            function (response) {
              let data = response.data;

              if (data.error) {
                return mainError.set(data.error);
              } else {
                return $scope.clear();
              }
            },
            /**
             * @param {HttpResponse} response
             * @returns {*}
             */
            function (response) {
              let data = response.data;
              let message;
              if (data.error) {
                message = data.error;
              } else {
                message = 'Failed to save reminder';
              }
              return mainError.set(message);
            }
          );
      };
      $scope.clear = function () {
        return $scope.reminder = manageReminder["new"](defaultOptions);
      };
      $scope.edit = function (reminderId) {
        let event;

        $scope.reminder = angular.copy(
          _.find($scope.remindersList.list, {
            ireminderid: reminderId
          })
        );

        event = _.find($scope.events.list, {
          calid: $scope.reminder.icalid_fk
        });
        if (!event) {
          retrieveEvents($scope.reminder.icalid_fk);
        }
      };
      $scope.$watch(function () {
        return $scope.reminder.icalid_fk;
      }, function () {
        let promise = events.get_teams_for($scope.reminder.icalid_fk);
        if (promise) {
          promise
            .then((response) => {
              let data = response.data;

              if (data.results) {
                return $scope.event_teams = data.results;
              }
            });
        }
      });
      $scope.$on('current_user_changed', function () {
        return retrieveEvents();
      });
      return init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/myHockeyTv/manageReminders/manageRemindersController.js